import { SortOrder } from "../sort-order";

export class DefaultDeviceCategoryFilters {
  name: string;
  description: string;
  sortField: string;
  sortOrder: SortOrder;
}
